import { useAppLock } from './AppLockContext';
import { WelcomeScreen } from './WelcomeScreen';
import { SetupScreen } from './SetupScreen';
import { LockScreen } from './LockScreen';
import { useStore } from '@/store';
import App from '@/App';

export function AppGate() {
  const { isUnlocked, isConfigured, lock, isEnabled, decision, skipEncryption, enableEncryption } =
    useAppLock();
  const requestLoadDemo = useStore((s) => s.requestLoadDemo);

  if (decision === 'pending') {
    return (
      <WelcomeScreen
        onEnable={enableEncryption}
        onSkip={skipEncryption}
        onLoadDemo={() => {
          // Stage 10 wizard escape hatch: bypass encryption prompt, then
          // signal TopBar to auto-open the demo dataset picker once the
          // app mounts.
          requestLoadDemo();
          skipEncryption();
        }}
      />
    );
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return;
          await lock.setup(password);
        }}
        onSkip={skipEncryption}
      />
    );
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false;
          return lock.unlock(password);
        }}
      />
    );
  }

  if (!isUnlocked) {
    return null;
  }

  return <App />;
}
